export function formatBytes(bytes: number | null | undefined): string {
  if (typeof bytes !== 'number' || !Number.isFinite(bytes) || bytes < 0) return '—';
  if (bytes === 0) return '0 B';

  const units = ['B', 'KiB', 'MiB', 'GiB', 'TiB'];
  const unitIndex = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / 1024 ** unitIndex;
  const precision = value >= 10 || Number.isInteger(value) ? 0 : 1;
  return `${value.toFixed(precision)} ${units[unitIndex]}`;
}

export function formatNanoCpus(nanoCpus: number | null | undefined): string {
  if (typeof nanoCpus !== 'number' || !Number.isFinite(nanoCpus) || nanoCpus < 0) return '—';
  const cpus = nanoCpus / 1_000_000_000;
  return `${Number.isInteger(cpus) ? cpus.toFixed(0) : cpus.toFixed(2).replace(/0+$/, '').replace(/\.$/, '')} vCPU`;
}
